// extracted by mini-css-extract-plugin
module.exports = {"welcome":"home_welcome__2Yga4"};